module.exports = __webpack_public_path__ + "userprofiles2.svg?a80f5aff0fe9b65e25372822f44b5d8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/userprofiles2.svg
// module id = 119
// module chunks = 0